import React from "react";
import styled from "styled-components";
import { I18n } from "react-redux-i18n";
import RotateBack from "editor/components/Icons/RotateBack";

const Tooltip = styled.span`
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translate(-50%,100%);
  background-color: #595959;
  border-radius: 3px;
  text-align: center;
  padding: 4px 15px;
  color: #ffffff;
  font-size: 11px;
  font-weight: 400;
  opacity: 0;
  pointer-events: none;
  z-index: 4;
  white-space: nowrap;
  transition: 0.3s all cubic-bezier(0.55, 0.3, 0.5, 0.9);
`;

const CustomButton = styled.button`
  position: relative;
  padding: 6px 4px;
  margin-right: 2px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    svg {
      fill: #44adf8;
    }

    ${Tooltip} {
      opacity: 1;
      bottom: -1px;
    }
  }

  &:focus {
    outline: none;
  }
`;

// create a class component named ResetToDefaultProps
const ResetToDefaultProps = ({ name, updaterFn, defaultProps }) => {
  return (
    <CustomButton
      onClick={(e) => {
        e && e.preventDefault();
        updaterFn({ prop: name, value: defaultProps });
      }}
      type="button"
    >
      <RotateBack size="14" color="#8F8F8F" />
      <Tooltip>{I18n.t("editPanel.resetToDefault")}</Tooltip>
    </CustomButton>
  );
};

export default ResetToDefaultProps;
